import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";

const TextInput = ({ value, onChange, innerRef }) => {
    // Create a proxy value in internal state to prevent the caret from jumping to the end every time the value updates
    const [currentValue, setCurrentValue] = useState(value);

    useEffect(() => {
        setCurrentValue(value);
    }, [value]);

    return (<Input
                type="text"
                value={currentValue}
                onChange={(e) => {
                    setCurrentValue(e.target.value);
                    onChange(e.target.value);
                }}
            />);
}

export default TextInput